import React, { useEffect, useState } from 'react';
import { SmartUpsellProductOfferProps } from './SmartUpsellProductOfferProps';
import { default as SharedCandycartCandyrack } from './SharedCandycartCandyrack';
import { default as PostPurchaseSmartUpsellProductOffer } from './PostPurchase';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import { getCart } from '../../shared/api/shared-app-requests';
import {
  IGNORE_TAGS,
  RecommendedProductsRequestConfig,
} from '../../shared/api/types';
import { appFunctions } from '../../utils/app-utils';

import { getMostExpensiveCartItem } from '@digismoothie/shared-candyrack';

const CANDYCART_RECOMMENDED_PRODUCTS_CONFIG: RecommendedProductsRequestConfig =
  {
    hostname: process.env.REACT_APP_LAST_UPSELL_API_HOSTNAME,
    appPrefix: 'candycart',
  };

const CANDYRACK_RECOMMENDED_PRODUCTS_CONFIG: RecommendedProductsRequestConfig =
  {
    hostname: process.env.REACT_APP_CUSTOMER_API_HOSTNAME,
    appPrefix: 'candyrack',
  };

const SmartUpsellProductOffer = ({
  parentProduct,
  currentApp,
  ...restProps
}: SmartUpsellProductOfferProps & { currentApp: REGISTERED_APPS }) => {
  const [candycartProductId, setCandycartProductId] = useState<number>();

  useEffect(() => {
    if (currentApp === REGISTERED_APPS.CANDYCART) {
      const getFirstCartProductId = async () => {
        const cart = await getCart();
        const mostExpensiveCartItem = getMostExpensiveCartItem(cart);
        // Use the most expensive product as input
        setCandycartProductId(mostExpensiveCartItem.product_id);
      };
      getFirstCartProductId();
    }
  }, [currentApp]);

  const getProductOffer = {
    [REGISTERED_APPS.CANDYCART]: candycartProductId ? (
      <SharedCandycartCandyrack
        {...restProps}
        productId={candycartProductId}
        ignoreTag={
          appFunctions.isBaseApp()
            ? IGNORE_TAGS.CR_IGNORE
            : IGNORE_TAGS.CC_IGNORE
        }
        recommendedProductsRequestConfig={
          appFunctions.isBaseApp()
            ? CANDYRACK_RECOMMENDED_PRODUCTS_CONFIG
            : CANDYCART_RECOMMENDED_PRODUCTS_CONFIG
        }
      />
    ) : (
      <></>
    ),
    [REGISTERED_APPS.CANDYRACK]: parentProduct ? (
      <SharedCandycartCandyrack
        parentProduct={parentProduct}
        productId={parentProduct.id}
        recommendedProductsRequestConfig={CANDYRACK_RECOMMENDED_PRODUCTS_CONFIG}
        {...restProps}
        ignoreTag={IGNORE_TAGS.CR_IGNORE}
      />
    ) : (
      <></>
    ),
    [REGISTERED_APPS.LAST_UPSELL]: (
      <PostPurchaseSmartUpsellProductOffer {...restProps} />
    ),
    [REGISTERED_APPS.PRODUCT_PAGE_PLACEMENT]: <></>,
  };

  return getProductOffer[currentApp];
};

export default SmartUpsellProductOffer;
